import { SessionTemplate, SessionTemplateCreate, SessionTemplateUpdate } from '../../domain/SessionTemplate';
import apiClient from '../../../../shared/infrastructure/api/client';

export class SessionTemplatesRepository {
    async listTemplates(): Promise<SessionTemplate[]> {
        const response = await apiClient.get<SessionTemplate[]>(`/templates/`);
        return response.data;
    }

    async getTemplate(templateId: string): Promise<SessionTemplate> {
        const response = await apiClient.get<SessionTemplate>(`/templates/${templateId}`);
        return response.data;
    }

    async createTemplate(data: SessionTemplateCreate): Promise<SessionTemplate> {
        const response = await apiClient.post<SessionTemplate>(`/templates/`, data);
        return response.data;
    }

    async updateTemplate(templateId: string, data: SessionTemplateUpdate): Promise<SessionTemplate> {
        const response = await apiClient.patch<SessionTemplate>(`/templates/${templateId}`, data);
        return response.data;
    }

    async deleteTemplate(templateId: string): Promise<void> {
        await apiClient.delete(`/templates/${templateId}`);
    }
}
